export const ru = {
    login: 'Яндекс логин',
    firstName: 'Имя',
    lastName: 'Фамилия',
};
